import React from 'react';
import { motion } from 'framer-motion';
import { PawPrint, Clock, User, Mountain, Sparkles, Tag } from 'lucide-react';
const tiers = [{
  title: 'Kratek sprehod',
  subtitle: 'do 30 min',
  price: '10 €',
  description: 'Sproščen in aktiven sprehod, prilagojen tempu in energiji psa.',
  icon: Clock,
  bg: 'bg-brand-pink-light',
  iconBg: 'bg-brand-pink',
  iconColor: 'text-white'
}, {
  title: 'Individualni sprehod',
  subtitle: 'dodatek za samo 1 psa',
  price: '+5 €',
  description: 'Za kužke, ki imajo raje mir, več pozornosti ali težje hodijo v skupini.',
  icon: User,
  bg: 'bg-brand-brown-light',
  iconBg: 'bg-brand-brown',
  iconColor: 'text-white'
}, {
  title: 'Dolg sprehod',
  subtitle: 'do 90 min',
  price: '+10 €',
  description: 'Za bolj aktivne pse, ki potrebujejo več gibanja, raziskovanja in igre.',
  icon: Mountain,
  bg: 'bg-brand-green-light',
  iconBg: 'bg-brand-green',
  iconColor: 'text-white'
}, {
  title: 'Sprehod z razvajanjem',
  subtitle: 'igrivo učenje, kratko česanje, dodatna igra, slikice',
  price: '+5 €',
  description: 'Malo dodatne pozornosti in zabave za vašega kužka 🐶',
  icon: Sparkles,
  bg: 'bg-brand-pink-light',
  iconBg: 'bg-brand-pink',
  iconColor: 'text-white'
}];
export function Pricing() {
  return <section className="relative py-12 px-6 max-w-7xl mx-auto" id="cenik" data-id="element-70">
      {/* Decorative paws */}
      <PawPrint className="absolute top-8 right-8 text-brand-brown opacity-10 w-12 h-12 -rotate-12 hidden md:block" data-id="element-71" />
      <PawPrint className="absolute bottom-32 left-4 text-brand-pink opacity-20 w-8 h-8 rotate-12 hidden md:block" data-id="element-72" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="text-center mb-10" data-id="element-73">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-74">
          Cenik
        </h2>
        <p className="text-lg text-brand-text/70 max-w-2xl mx-auto" data-id="element-75">
          Pošteni in jasni ceni, prilagojeni potrebam vašega kužka.
        </p>
      </motion.div>

      {/* Pricing cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-76">
        {tiers.map((tier, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        delay: index * 0.1
      }} className={`${tier.bg} rounded-3xl p-6 flex flex-col text-left transition-all duration-300 hover:-translate-y-2 hover:shadow-lg shadow-soft relative overflow-hidden`} data-id="element-77">
            <div className={`${tier.iconBg} w-12 h-12 rounded-full flex items-center justify-center mb-4 shadow-sm`} data-id="element-78">
              <tier.icon className={`w-6 h-6 ${tier.iconColor}`} data-id="element-79" />
            </div>

            {/* Title + subtitle locked to a consistent height so prices line up across cards */}
            <div className="min-h-[4.5rem] mb-4" data-id="element-80">
              <h3 className="font-bold text-brand-text text-xl leading-tight mb-1" data-id="element-81">
                {tier.title}
              </h3>
              <p className="text-sm text-brand-text/60 leading-snug" data-id="element-82">
                {tier.subtitle}
              </p>
            </div>

            <div className="font-display text-4xl font-bold text-brand-text mb-4 pb-4 border-b border-brand-text/10" data-id="element-83">
              {tier.price}
            </div>

            <p className="text-sm text-brand-text/75 leading-relaxed" data-id="element-84">
              {tier.description}
            </p>
          </motion.div>)}
      </div>

      {/* Special offer banner */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      delay: 0.2
    }} className="mt-8 relative bg-brand-brown rounded-[2rem] p-6 md:p-8 shadow-soft overflow-hidden" data-id="element-85">
        {/* Decorative paws inside banner */}
        <PawPrint className="absolute -top-4 -right-2 text-white/10 w-32 h-32 rotate-12" data-id="element-86" />
        <PawPrint className="absolute -bottom-6 left-1/3 text-white/10 w-20 h-20 -rotate-12 hidden md:block" data-id="element-87" />

        <div className="relative z-10 flex flex-col md:flex-row items-center md:items-center justify-between gap-4 text-center md:text-left" data-id="element-88">
          <div className="flex items-center gap-4" data-id="element-89">
            <div className="bg-white/20 backdrop-blur-sm w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-90">
              <Tag className="w-7 h-7 text-white" data-id="element-91" />
            </div>
            <div data-id="element-92">
              <h3 className="font-display text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-93">
                🐾 Paket 10 sprehodov
              </h3>
              <p className="text-white/90 text-base md:text-lg" data-id="element-94">
                Ob nakupu 10 sprehodov naenkrat prejmete{' '}
                <span className="font-bold" data-id="element-95">15% popusta</span>.
              </p>
            </div>
          </div>
          <div className="bg-brand-pink rounded-full px-8 py-4 font-display font-bold text-brand-text shadow-md whitespace-nowrap text-3xl md:text-4xl" data-id="element-96">
            −15%
          </div>
        </div>
      </motion.div>

      {/* Footnote */}
      <motion.p initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="text-center text-sm text-brand-text/60 mt-6 italic" data-id="element-97">
        Sprehode izvajava po predhodnem dogovoru in glede na razpoložljivost.
      </motion.p>
    </section>;
}